import React from 'react';
import Menu from '@material-ui/core/Menu';

function CustomMenu(props) {
  const {...rest} = props;
  return (<Menu {...rest}></Menu>)
}

export default CustomMenu;